import React from "react";
import PageHeader from "components/common/PageHeader";
import EmbeddedSophosApp from "./EmbeddedSophosApp";
const SophosApp = () => /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(PageHeader, { title: "Sophos Input" }, /* @__PURE__ */ React.createElement("span", null, "This feature retrieves log messages from Sophos central.")), /* @__PURE__ */ React.createElement(EmbeddedSophosApp, null));
export default SophosApp;
